<template>
  <div class="listbox">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.listbox {
  display: flex;
  flex-direction: column;
  gap: var(--t-spacing-xs);
  padding-block: var(--t-spacing-sm);

  background-color: var(--t-color-neutral-white);
  border-radius: var(--t-border-radius-sm);
  box-shadow: var(--t-shadow-sm);
}
</style>
